/* template */
<template><div class="backgroundConent"><div class="navbarBg"><es-navbar title="密码找回"></es-navbar></div><div class="es-input-tips">请输入您注册12306帐号时使用的手机号码</div><div class="backgroundStyle"><div class="es-background-card"><div class="inputContainerStyle"><div class="messageStyle">手机号码</div><div class="es-input-id-number"><mpx-input :style='["width: 100%"] | transRpxStyle' type="text" placeholder="请输入已经核验手机号" :value="phoneInput" mpxModelEvent="input" @mpxModel='__model("phoneInput", $event, ["value"], undefined)' :maxlength="(11)" class="inputStyle"/></div></div><div class="inputContainerStyle"><div class="messageStyle">新密码</div><div class="es-input-id-number"><mpx-input :style='["width: 100%"] | transRpxStyle' :type="(passwordType)" placeholder="不少于6位" :value="password" mpxModelEvent="input" @mpxModel='__model("password", $event, ["value"], undefined)' class="inputStyle"/><div class="es-retrieval-error" v-if="(passwordInputStatus)">密码不能为空</div><mpx-view @tap="eyehandle" class="icon-eye-close"><template v-if="(!eyeState)"><mpx-image src="https://pt-starimg.didistatic.com/static/starimg/img/LpvhCITOpN1642147541419.png" class="es-eye"></mpx-image></template><template v-else><mpx-image src="https://pt-starimg.didistatic.com/static/starimg/img/FLGAZitaXS1642147590072.png" class="es-eye"></mpx-image></template></mpx-view></div></div><div class="inputContainerStyle"><div class="messageStyle">确认密码</div><div class="es-input-id-number"><mpx-input :style='["width: 100%"] | transRpxStyle' :type="(passwordType)" placeholder="请再次输入密码" :value="confirmPassword" mpxModelEvent="input" @mpxModel='__model("confirmPassword", $event, ["value"], undefined)' autocomplete="off" class="inputStyle"/><div class="es-retrieval-error" v-if="(confirmPasswordStatus)">密码不能为空</div></div></div><div class="inputContainerStyle"><div class="messageStyle">验证码</div><mpx-input type="text" placeholder="请输入短信验证码" :value="vCode" mpxModelEvent="input" @mpxModel='__model("vCode", $event, ["value"], undefined)' :maxlength="(6)" class="inputStyle"/><mpx-view @tap="getCode" class="es-get-code" v-if="(show)">获取验证码</mpx-view><div class="es-get-code es-get-code-gray" v-if="(!show)">{{ auth_time }}秒后重新发送</div></div></div></div><div class="footer"><div class="es-next-step-content"><div class="es-next-step"><mpx-view @tap="onClickSubmit" class="buttonStyle">提交</mpx-view></div></div></div><es-dialog :show="(showDialog)" confirmButtonText="知道了" @confirm="toLoginPage" @close="close" :showClass="(true)" align="center" class="es-modi-dialog"><div slot="title"><div class="es-modi-icon"><es-icon name="check-circle-filled" size="50"/></div><div>密码修改成功</div></div><div slot="content" class="es-dialog-content"><div>请重新登录</div></div></es-dialog></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m61ee5443"}'>
  @import '~@/mixins/stylus/color.styl'

  .goPageBack
    position absolute
    left 0px
    top 2px
    z-index 999
    width 100%
    height 60px
  .backgroundConent
    background-color #F0F1F4
    height 100%
  .navbarBg
    background-color $train-color-fff
  .es-content-hover
    color $train-color-theme-blue
  .es-background-card
    background #ffffff
    border-radius 8px
    padding 5px 0px 0px 5px
  .tab-label
    padding 0 5px
    position absolute
    font-size 10px
    height 18px
    line-height 18px
    color #ffffff
    background #FD6C19
    border-radius 9px
    border 1px solid #ffffff
  .backgroundStyleBox
    display flex
    flex-direction column
    justify-content space-between
    box-sizing border-box
    background-color $train-color-background
  .backgroundStyle
    padding 12px
    background-color $train-color-background
  .title
    margin-left 10px
    padding 10 20
    color black
    font-size 20px
    text-align center
    background #FD6C19
    border 1px solid #FFFFFF
    width 250px
    height 25px
  .titleStyle
    padding-top 0
    padding-bottom 12px
    color #000000
    font-size 16px
  .titleStyles
    padding-top 24px
    padding-bottom 12px
    color #000000
    font-size 16px
  .contentStyle
    color $train-color-666
    font-size 14px
  .messageStyle
    color $train-color-333
    font-size 15px
    display inline-block
    width 70px
  .messageBorder
    color #C0C0C0
    padding 0 10px
  .buttonStyle
    margin-top 16px
    color white
    background $train-color-theme-blue
    font-size 16px
    border-color $train-color-theme-blue
    padding 10px 10px
    text-align center
    border-radius 8px
  .search
    color $train-color-divider-ccc
    font-size 15px
    height 44px
    padding 13px
    width 100%
    outline none
    box-sizing border-box
  .inputContainerStyle
    padding 10px
    display flex
    align-items center
    width 100%
    box-sizing border-box
    position relative
    height 55px
  .inputStyle
    font-size 15px
    color $train-color-666
    outline none
    width 250px
    height 21px
  .inputStyle::placeholder
    color $train-color-999
  .button-not-active
    background $train-color-divider-ccc
  .es-next-step
    height 80px
    background #ffffff
    padding 0px 16px
  .es-next-box
    width 30px
    height 25px
    position absolute
    right 0
    top 10px
    color $train-color-666
  .es-input-id-number
    position relative
    width 250px
  .es-input-id-number:after
    content ' '
    display block
    width 100%
    height 1px
    background RGB(240, 241, 244)
    position absolute
    left 0
    top 38px
    z-index 1
  .es-retrieval-error
    color #f00
    position absolute
    left 0px
    top 21px
    font-size 13px
    width 100%
    border-bottom 1px red solid
  .not-hover
    display none
  .icon-eye-close
    position absolute
    width 20px
    height 20px
    right 0px
    top 1px
    z-index 99
  .es-eye
    width 20px
    height 20px
  .es-get-code
    border 1px RGB(20, 115, 255) solid
    border-radius 6px
    padding 5px
    position absolute
    right 20px
    top 13px
    font-size 13px
    color $train-color-theme-blue
    z-index 99
  .es-get-code-gray
    color $train-color-999
    border 1px solid $train-color-999
  .hidden
    display none
  .es-input-tips
    color #247CFF
    font-size 14px
    background-color #EDF4FF
    background linear-gradient(left right, #EDF4FF, #ffffff)
    padding 10px 12px
  .es-modi-icon
    height 50px
    text-align center
    color $train-color-theme-blue
  .es-next-step-content
    position absolute
    width 100%
    bottom 0px
    background $train-color-fff
    z-index 10
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m61ee5443"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./password-modification.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./password-modification.mpx?ctorType=page&index=0&isPage&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["m61ee5443"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {"component":true},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-button':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/button/index.mpx?isComponent&outputPath=components%2Findexbc68cb48%2Findex")),'es-dialog':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/dialog/index.mpx?isComponent&outputPath=components%2Findex3651661c%2Findex")),'es-icon':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'drawer-bottom':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/drawer-bottom/index.mpx?isComponent&outputPath=components%2Findexeb3fdc9e%2Findex")),'mpx-input':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-input.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
